import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TaskDossier\UpdateTaskDossierStatusController::__invoke
* @see app/Http/Controllers/TaskDossier/UpdateTaskDossierStatusController.php
* @route '/api/task-dossier/{id}/status'
*/
const UpdateTaskDossierStatusController437f8718089b6c9f2861c2231a9de209 = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateTaskDossierStatusController437f8718089b6c9f2861c2231a9de209.url(args, options),
    method: 'put',
})

UpdateTaskDossierStatusController437f8718089b6c9f2861c2231a9de209.definition = {
    methods: ["put"],
    url: '/api/task-dossier/{id}/status',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\TaskDossier\UpdateTaskDossierStatusController::__invoke
* @see app/Http/Controllers/TaskDossier/UpdateTaskDossierStatusController.php
* @route '/api/task-dossier/{id}/status'
*/
UpdateTaskDossierStatusController437f8718089b6c9f2861c2231a9de209.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return UpdateTaskDossierStatusController437f8718089b6c9f2861c2231a9de209.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\TaskDossier\UpdateTaskDossierStatusController::__invoke
* @see app/Http/Controllers/TaskDossier/UpdateTaskDossierStatusController.php
* @route '/api/task-dossier/{id}/status'
*/
UpdateTaskDossierStatusController437f8718089b6c9f2861c2231a9de209.put = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateTaskDossierStatusController437f8718089b6c9f2861c2231a9de209.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\TaskDossier\UpdateTaskDossierStatusController::__invoke
* @see app/Http/Controllers/TaskDossier/UpdateTaskDossierStatusController.php
* @route '/api/task-dossier/update-status/{task_dossier}'
*/
const UpdateTaskDossierStatusController18b1089eb4635a2d1e9918c08aa9d824 = (args: { task_dossier: string | number | { id: string | number } } | [task_dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateTaskDossierStatusController18b1089eb4635a2d1e9918c08aa9d824.url(args, options),
    method: 'put',
})

UpdateTaskDossierStatusController18b1089eb4635a2d1e9918c08aa9d824.definition = {
    methods: ["put"],
    url: '/api/task-dossier/update-status/{task_dossier}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\TaskDossier\UpdateTaskDossierStatusController::__invoke
* @see app/Http/Controllers/TaskDossier/UpdateTaskDossierStatusController.php
* @route '/api/task-dossier/update-status/{task_dossier}'
*/
UpdateTaskDossierStatusController18b1089eb4635a2d1e9918c08aa9d824.url = (args: { task_dossier: string | number | { id: string | number } } | [task_dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { task_dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { task_dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            task_dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        task_dossier: typeof args.task_dossier === 'object'
        ? args.task_dossier.id
        : args.task_dossier,
    }

    return UpdateTaskDossierStatusController18b1089eb4635a2d1e9918c08aa9d824.definition.url
            .replace('{task_dossier}', parsedArgs.task_dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\TaskDossier\UpdateTaskDossierStatusController::__invoke
* @see app/Http/Controllers/TaskDossier/UpdateTaskDossierStatusController.php
* @route '/api/task-dossier/update-status/{task_dossier}'
*/
UpdateTaskDossierStatusController18b1089eb4635a2d1e9918c08aa9d824.put = (args: { task_dossier: string | number | { id: string | number } } | [task_dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateTaskDossierStatusController18b1089eb4635a2d1e9918c08aa9d824.url(args, options),
    method: 'put',
})

/**
* Multiple routes resolve to \App\Http\Controllers\TaskDossier\UpdateTaskDossierStatusController::UpdateTaskDossierStatusController, so this export is a
* dictionary keyed by URI rather than a callable, with the verbs prefixed where two routes share a URI.
* Call a specific route with `UpdateTaskDossierStatusController['<key>'](...)`, or import the route by name from your
* generated `routes/` directory.
*/
const UpdateTaskDossierStatusController = {
    '/api/task-dossier/{id}/status': UpdateTaskDossierStatusController437f8718089b6c9f2861c2231a9de209,
    '/api/task-dossier/update-status/{task_dossier}': UpdateTaskDossierStatusController18b1089eb4635a2d1e9918c08aa9d824,
}

export default UpdateTaskDossierStatusController